import type { UseOpenApiQueryOptions } from "@packages/sdk";
import { useOpenApiQuery } from "@packages/sdk";
import { differenceInMilliseconds, endOfDay } from "date-fns";

const urlBackendPath = "/bible/daily-readings" as const;

export const useRequestDailyReadings = (
  props: Omit<
    UseOpenApiQueryOptions<typeof urlBackendPath>,
    "urlBackendPath" | "staleTime" | "enabledWithoutSessionToken"
  > = {},
) =>
  useOpenApiQuery<typeof urlBackendPath>({
    urlBackendPath,
    staleTime: () => differenceInMilliseconds(endOfDay(new Date()), new Date()),
    enabledWithoutSessionToken: false,
    ...props,
  });
